import { cn } from "@/lib/utils";

interface ShellProps {
	children: React.ReactNode;
	className?: string;
}

export const Shell = ({ children, className }: ShellProps) => {
	return (
		<div className={cn("container max-w-3xl mx-auto p-4", className)}>
			{children}
		</div>
	);
};
